import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, callGameServerApi, getInlineLoader, isAlphanumeric, resolveOrientation } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import SwipeTabs from '../components/SwipeTabs';
import { copyText, formatDate } from '../Helpers';
import { GAME_TYPES } from '../Constants';

export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";
  const [ myMatches, setMyMatches ] = useState([]);
  const [ availableMatches, setAvailableMatches ] = useState([]);
  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);

  

  const getMatches = () => {
    return new Promise(async resolve => {
      setLoading(true);
      //await callApi('get_user_matches.php', {}).then(response => {
      await callGameServerApi('get-user-matches', {}).then(response => {

        setLoading(false);
        if(response.status === 1) {
          setMyMatches(response.myMatches);
          setAvailableMatches(response.availableMatches);
          resolve();
        } else {
          appContext.tellError('Could not fetch matches');
          appContext.tellError(response.msg)
        }
      })
    })
  }

  const init = async () => {
    appContext.changeOrientation(requiredOrientation);
    //appContext.orientationChecker();
    await getMatches().then(() => {
      setReady(true);
    })
  }


  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();
    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  if(ready) {
    return (
      <>
        <TopBar title="Matches"/>
        <div className="FullPane" id="_fullPane1" data-support-top-bar={true}>
          <SwipeTabs
            tabs={[
              {
                id: 'my_matches',
                title: 'My Matches',
                view: (
                  <div className="container-fluid">
                    <h5 style={{ marginBottom: "20px",  marginTop: "30px" }} className="font-light text-muted">My Matches ({myMatches.length})</h5>
                    {
                      myMatches.map((item, i) => {
                        return (
                          <div className="text-start z-depth-1" style={{ padding: "10px", marginBottom: "20px" }} key={i}>
                            <div className="d-flex justify-content-between">
                              <h3>
                                {item.uid}<br/>
                                <small style={{ fontSize: "12px" }} className="text-muted">Game ID</small>
                                <hr/>
                                <span className='font-bold text-muted' style={{ fontSize: "15px" }}>
                                  {
                                    (item.type === GAME_TYPES.ARUBASTINI) ?
                                    "Cards - Arubastini": ""
                                  }

                                  {
                                    (item.type === GAME_TYPES.LASTCARD) ?
                                    "Cards - LastCard": ""
                                  }

                                  {
                                    (item.type === GAME_TYPES.BRAZILIAN_CHECKERS) ?
                                    "Brazilian Checkers": ""
                                  }

                                  {
                                    (item.type === GAME_TYPES.SPANISH_CHECKERS) ?
                                    "Spanish Checkers": ""
                                  }
                                  
                                </span><br/>
                              </h3>
                              <small className="text-muted font-light">#{(myMatches.length) - (i)}</small>
                            </div>
                            <h6 className="font-light text-goldish" style={{ marginTop: "20px" }}>
                              {item.status}<br/>
                              <small style={{ fontSize: "12px" }} className="text-muted">status</small>
                            </h6>

                            <div className="text-end">
                              <button
                                onClick={() => { appContext.navTo({
                                  item: 'view',
                                  subItem: 'browse_game',
                                  extraItem: item.uid,
                                });}}
                                className="btn btn-rounded btn-sm text-goldish">View</button>

                              <button onClick={() => { copyText(item.uid); appContext.tellMessage("Game ID was copied")}} className="btn btn-rounded btn-sm bg-dark text-light">Copy ID</button>
                            </div>
                          </div>
                        );
                      })
                    }
                  </div>
                ),
              },
              {
                id: 'available_matches',
                title: 'Available Matches',
                view: (
                  <div className="container-fluid">
                    <h5 style={{ marginBottom: "20px",  marginTop: "30px" }} className="font-light text-muted">Available Matches ({availableMatches.length})</h5>
                    {
                      availableMatches.map((item, i) => {
                        return (
                          <div className="text-start z-depth-1" style={{ padding: "10px", marginBottom: "20px" }} key={i}>
                            <div className="d-flex justify-content-between">
                              <h3>
                                {item.uid}<br/>
                                <small style={{ fontSize: "12px" }} className="text-muted">Game ID</small>
                                <hr/>
                                <span className='font-bold text-muted' style={{ fontSize: "15px" }}>
                                  {
                                    (item.type === GAME_TYPES.ARUBASTINI) ?
                                    "Cards - Arubastini": ""
                                  }

                                  {
                                    (item.type === GAME_TYPES.LASTCARD) ?
                                    "Cards - LastCard": ""
                                  }

                                  {
                                    (item.type === GAME_TYPES.BRAZILIAN_CHECKERS) ?
                                    "Brazilian Checkers": ""
                                  }

                                  {
                                    (item.type === GAME_TYPES.SPANISH_CHECKERS) ?
                                    "Spanish Checkers": ""
                                  }
                                  
                                  
                                </span><br/>
                              </h3>
                              <small className="text-muted font-light">#{(availableMatches.length) - (i)}</small>
                            </div>

                            <h6 className="font-light text-goldish" style={{ marginTop: "20px" }}>
                              <span className="font-semi-bold">{item.playerInfo.username}</span><br/>
                              <small style={{ fontSize: "12px" }} className="text-muted">Host</small>
                            </h6>

                            <h6 className="font-light text-goldish" style={{ marginTop: "20px" }}>
                              {formatDate(item.dateCreated)}<br/>
                              <small style={{ fontSize: "12px" }} className="text-muted">Creation Date</small>
                            </h6>

                            <div className="text-end">
                              <button
                                onClick={() => { appContext.navTo({
                                  item: 'view',
                                  subItem: 'browse_game',
                                  extraItem: item.uid,
                                });}}
                                className="btn btn-rounded btn-sm bg-dark">View or Join</button>

                            </div>
                          </div>
                        );
                      })
                    }
                  </div>
                ),
              }
            ]}
          />
        </div>
      </>
    )
  } else {
    return (
      <div className="FullPane">
        {getInlineLoader()}
      </div>
    )
  }
}
